import { gql } from "@apollo/client"

export type SingleStringValue = {
  value: string;
}

export interface Def_MutationResponse {
  code: string;
  success: boolean;
  message: string;
}

export type LoginArgs = {
  username: string;
  password: string;
}

export interface LoginResponse {
  authenticate: Def_MutationResponse;
}
export const USER_LOGIN = gql`
  query Authenticate($username: String!, $password: String!) {
    authenticate(username: $username, password: $password) {
      code
      success
      message
    }
  }`;

export type CreateArgs = {
  username: string;
  password: string;
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
}
export interface CreateUserResponse {
  create: Def_MutationResponse;
}
export const CREATE_USER = gql`
query UserCreate($username: String!, $password: String!, $firstname: String, $lastname: String, $phone: String, $email: String) {
  user {
    create(username: $username, password: $password, firstname: $firstname, lastname: $lastname, phone: $phone, email: $email) {
      code
      success
      message
    }
  }
}`;

export interface Farms_Data {
  farm_id: number
  name: string
  domain: string
  legacy: boolean
}

export type UserFarmsArgs = {
  farm_id?: number;
}

export interface FarmsResponse {
  user: {
    companies: Farms_Data[];
  }
}

export const USER_FARMS = gql`
  query Companies {
    user {
      companies {
        farm_id:company_id
        name
        domain
        legacy
      }
    }
  }
`;

export interface User_Data {
  user_id:number;
  username:string;
  firstname: string;
  lastname: string;
  phone: string;
  email: string;
  address: string;
  country: string;
}

export type UserInfoArgs = {
  jwt: string;
}

export interface UserInfoResponse {
  user: {
    info: User_Data;
  }
}
export const USER_INFO = gql`
query UserInfo($jwt: String!) {
  user {
    info(jwt: $jwt) {
      address
      country
      email
      firstname
      lastname
      phone
      user_id
      username
    }
  }
}`;

export type UpdateUserInfoArgs = {
  jwt: string;
} & Partial<User_Data>

export interface UpdateUserInfoResponse {
  user: {
    updateInfo: Def_MutationResponse;
  }
}

export const UPDATE_USER_INFO = gql`
  mutation UpdateInfo($jwt: String!, $firstname: String!, $lastname: String!, $phone: String!, $email: String!, $country: String!, $address: String!) {
    user {
      updateInfo(jwt: $jwt, firstname: $firstname, lastname: $lastname, phone: $phone, email: $email, address: $address, country: $country) {
        code
        success
        message
      }
    }
  }  
`;

export interface Farm_Data {
  company_id: number;
  domain: string;
  name: string;
  city: string;
  street: string;
  phone: string;
  vat: string;
  email: string;
}

export type FarmInfoArgs = {
  domain: string;
}
  
export interface FarmInfoResponse {
  company: {
    info: Farm_Data
  }
}

export const FARM_INFO = gql`
  query FarmInfo($domain: String!) {
    company {
      info(domain: $domain) {
        company_id
        name
        domain
        city
        street
        phone
        vat
        email
      }
    }
  }`;
    
export type UpdateFarmInfoArgs = {
  domain: string;
} & Partial<Farm_Data>
  
export interface UpdateFarmInfoResponse {
  company: {
    updateInfo: Def_MutationResponse;
  }
}

export const UPDATE_FARM_INFO = gql`
  mutation UpdateInfo($domain: String!, $city: String!, $street: String!, $phone: String!, $vat: String!, $email: String!) {
    company {
      updateInfo(domain: $domain, city: $city, street: $street, phone: $phone, vat: $vat, email: $email) {
        code
        success
        message
      }
    }
  }
`;

export const GET_SERVER_IP = gql`
  query ServerIp {
    serverIp
  }
`